import { useMemo } from 'preact/hooks';
import Action from '@/widgets/ProductDetailsHero/parts/Action/Action.tsx';
import { type Product } from '@/domain/Product';
import useTranslations from '@/widgets/hooks/useTranslations';
import type { Translations } from '@/widgets/ProductDetailsHero/config';
import styles from './SaveWithABundle.module.scss';
import useQueryStringStore from '@/widgets/hooks/useQueryStringStore';
import type { PersistedState } from '@/widgets/ProductDetailsHero/Store';
import { trackPdpInteraction } from '@/widgets/ProductDetailsHero/Tracking';
import otherWaysToShopSectionStyles from '../../OtherWaysToShopSection.module.scss';

type SaveWithABundleProps = {
  bundles: Product[];
};

const TRACKING_ACTION_TYPE = 'bundle config';

export default function SaveWithABundle({ bundles }: SaveWithABundleProps) {
  const { t } = useTranslations<Translations>();
  const [, setState] = useQueryStringStore<PersistedState>();

  const cheapestBundle = useMemo(
    () =>
      bundles?.length
        ? bundles.reduce((cheapest, product) =>
            product.pricing.price < cheapest.pricing.price ? product : cheapest
          )
        : undefined,
    [bundles]
  );

  if (!cheapestBundle) {
    return null;
  }

  const priceLabel = t(
    'productDetailsHero.otherWaysToShopSection.fromPriceLabel',
    {
      price: cheapestBundle.pricing.price
    }
  );

  return (
    <Action
      class={styles.button}
      onClick={() =>
        setState({
          openModal: 'bundle-options'
        })
      }
      onImpression={() => trackPdpInteraction(TRACKING_ACTION_TYPE)}
    >
      <Action.Icon icon="24/payment/gift-card" />
      <Action.IconLabel
        class={otherWaysToShopSectionStyles.label}
        label={t(
          'productDetailsHero.otherWaysToShopSection.saveWithABundleLabel'
        )}
      />
      <Action.CtaLabel
        class={otherWaysToShopSectionStyles.priceLabel}
        label={priceLabel}
      />
      <Action.Icon icon="24/symbol/chevron-right" />
    </Action>
  );
}
